import Flickity from 'flickity';
import $ from 'jquery';

$(document).ready(function() {
  const $testimonial = $('.m-testimonial');


  $testimonial.each(function () {
    const $thisTestimonial = $(this);

    // Listen controls
    $thisTestimonial.find('.controls a').on('click', function (event) {
      event.preventDefault();

      //
      const $this = $(this);
      const index = $this.closest('li').index();

      //
      $thisTestimonial.find('.slide.active').removeClass('active');
      $thisTestimonial.find('.slide').eq(index).addClass('active');

      //
      $thisTestimonial.find('.controls .active').removeClass('active');
      $this.closest('li').addClass('active');
    });

  });

  const $slider = $('.ekomi-slider');
  
  $slider.each(function () {
    const $thisSlider = $(this);
    const slider = $thisSlider[0];

    
    const flkty = new Flickity(slider, {
      cellSelector: '.ekomi-slide',
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      groupCells: false,
      autoPlay: 10000,
      adaptiveHeight: true
    });
  });

  
});



// WEBPACK FOOTER //
// ./app/ui/modules/testimonial/index.js